import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { func, object, bool } from "prop-types";
import { logUserOut } from "utils/helperFunctions";
import CriteriaLogo from "resources/images/Criteria-logo-blue.svg";

const SessionExpirationModal = ({
  onLogin,
  userData,
  showModal,
  loginLoading,
}) => {
  const [password, setPassword] = useState("");
  const submitHandler = (e) => {
    e.preventDefault();
    const formData = {
      emailAddress: userData.emailAddress,
      password,
    };
    onLogin(formData);
  };

  return (
    <Modal dialogClassName="logged-out-modal" show={showModal}>
      <Modal.Body>
        <img
          src={CriteriaLogo}
          alt="warning"
          style={{ height: 35, width: 138 }}
          className="mr-2 mb-1"
        />
        <h1>{`For your security, you've been logged out.`}</h1>
        <p>Enter your password to log back in.</p>
        <Form className="logged-out-form" onSubmit={submitHandler}>
          <Form.Group>
            <Form.Control
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              disabled={loginLoading}
              placeholder="Enter your password here"
              style={{ cursor: loginLoading ? "wait" : "text" }}
            />
          </Form.Group>
          <Button
            type="submit"
            disabled={loginLoading}
            style={{ cursor: loginLoading ? "wait" : "pointer" }}
          >
            {" "}
            Log In{" "}
          </Button>
          <Button
            variant="outline-primary"
            className="mt-1"
            style={{ border: 0 }}
            onClick={() => logUserOut()}
          >
            {" "}
            Log Out{" "}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

SessionExpirationModal.propTypes = {
  onLogin: func.isRequired,
  userData: object,
  showModal: bool,
  loginLoading: bool,
};
export default SessionExpirationModal;
